import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Col, Input, Row } from 'antd';
import { Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
    addKeyValuePair,
  clearUserGroups,
  getGroupById,
  getGroups,
  getUserData,
  updateUser,
  updateUserGroup,
} from 'store/adminPanel/actions';

const AddKeyModal = ({ isVisible, setVisible, usersId }) => {
  const dispatch = useDispatch();

  const user = useSelector(state => state.adminPanel.selectedUser);
  const [userID, setUserID] = useState(user?.id);

  const [infoKey, setInfoKey] = useState();
  const [infoDetail, setInfoDetail] = useState();

  useEffect(() => {
    setUserID(user?.id);
  }, [user]);

  const handleOk = () => {
    dispatch(addKeyValuePair(userID, infoKey, infoDetail))
    .then(response=>{
      dispatch(getUserData(usersId));
    })
    setVisible(false);
  };

  return (
    <Modal
      isVisible={isVisible}
      Icon={Pencil}
      onCancel={() => {setVisible(false); setInfoKey(); setInfoDetail();}}
      onOk={() => handleOk()}
      title={
        <h1
          style={{
            color: '#2d97e9',
            marginTop: '0.563rem',
            marginLeft: '1.875rem',
          }}
        >
          Add User Info Key/Value Pair
        </h1>
      }
      okButtonProps={{disabled: !infoKey || !infoDetail}}
      width={817}
      okText="Add"
    >
      <Row gutter={8}>
        <Col span={24} style={{ marginTop: '20px' }}>
          <label htmlFor="user-id" className="input-titles">
            User ID
          </label>
          <Input
            disabled
            id="user-id"
            style={{ height: '40px' }}
            value={userID}
          ></Input>
        </Col>
        <Col span={12} style={{ marginTop: '20px' }}>
          <label htmlFor="info-key" className="input-titles">
            Key
          </label>
          <Input
            id="info-key"
            style={{ height: '40px' }}
            placeholder='Enter Variable Key'
            value={infoKey}
            onChange={event => {
              setInfoKey(event.target.value);
            }}
          ></Input>
        </Col>
        <Col span={12} style={{ marginTop: '20px' }}>
          <label htmlFor="info-detail" className="input-titles">
            Value
          </label>

          <Input
            id="info-detail"
            style={{ height: '40px' }}
            placeholder='Enter Variable Value'
            value={infoDetail}
            onChange={event => {
              setInfoDetail(event.target.value);
            }}
          ></Input>
        </Col>
      </Row>
    </Modal>
  );
};

export default AddKeyModal;
